// src/component-project/ApproveChangeDevice/TabAdminAssign.js
import React from 'react';
import { Grid, Typography } from '@mui/material';
import ComboBox from 'src/components/Input/ComboBox';
import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';

export default function TabAdminAssign({
    t,
    dataCabinet,
    selectCabinetAdmin,
    setSelectCabinetAdmin,
    dataDrawerAdmin,
    selectDrawerAdmin,
    setSelectDrawerAdmin,
    dataCellAdmin,
    selectedCellAdmin,
    setSelectedCellAdmin,
    deviceData,
    requestData
}) {
    return (
        <>
            {/* Chọn Tủ (Enabled cho Admin) */}
            <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                <ComboBox
                    label={t('choose_cabinet')}
                    sizeCbb="medium"
                    displayLabel="label"
                    valueSelect={dataCabinet.find((ele) => ele.value === selectCabinetAdmin)}
                    valueEqual="value"
                    getValue={(e) => setSelectCabinetAdmin(e?.value || 0)}
                    selectOption={dataCabinet}
                    required
                    disabled={false} 
                />
            </Grid>

            {/* Chọn Ngăn (Enabled cho Admin) */}
            <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                <ComboBox
                    label={t('choose_drawer')}
                    sizeCbb="medium"
                    displayLabel="label"
                    valueSelect={dataDrawerAdmin.find((ele) => ele.value === selectDrawerAdmin)}
                    valueEqual="value"
                    getValue={(e) => setSelectDrawerAdmin(e?.value || 0)}
                    selectOption={dataDrawerAdmin}
                    required
                    disabled={false}
                />
            </Grid>

            {/* Bàn cờ chọn vị trí mới */}
            {dataCellAdmin.length > 0 && selectDrawerAdmin > 0 && (
                <>
                    <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                        {t('direc_admin_assign')}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            textAlign: 'center',
                            display: 'block',
                            fontStyle: 'italic',
                            width: '100%',
                            color: '#adb1b5',
                        }}
                    >
                        {t('warning_cell_not_right_device_or_not_enough')}
                    </Typography>

                    <ChessBoardSelectCell
                        typeCabinet={deviceData?.cabinet_type}
                        cell_id_request={requestData?.cell_request_id}
                        device_cd={deviceData?.device_cd}
                        onSelect={(pos) => {
                             setSelectedCellAdmin(pos);
                        }}
                        dataCell={dataCellAdmin}
                        just_device_cd={true}
                        qty={deviceData?.qty}
                        selectedCell={selectedCellAdmin}
                    />
                </>
            )}
        </>
    );
}